import JSONParser from '@core/scripts/helper/json-parser';

let cachedTopCategoriesModel = null;

const hookname = 'jsh-top-categories-model-holder';

function load(moduleScope) {

    if (!cachedTopCategoriesModel) {
        cachedTopCategoriesModel = JSONParser.tryParseJSON(moduleScope.getAttribute(hookname));
    }

    return cachedTopCategoriesModel;
}

export default {
    load
};



